module.exports = __webpack_public_path__ + "img/info-land.c8e3e7d0.webp";